module.exports = __webpack_public_path__ + "static/media/project6.28999928.jpg";